import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "item", "candidate"]

  add({ params: { id } }) {
    const candidate = this.candidateTargets.find((template) => this.#matches(template, id))
    if (this.itemTargets.some((item) => this.#matches(item, id))) return

    this.listTarget.append(candidate.content.cloneNode(true))
  }

  remove({ params: { id } }) {
    this.itemTargets.find((item) => this.#matches(item, id)).remove()
  }

  preventSubmit(event) {
    event.preventDefault()
  }

  #matches(element, id) {
    return Number(element.dataset.listingId) === id
  }
}
